export default __webpack_public_path__ + "static/media/Workshop.256.6115a6e2.png";